import { Component, Inject, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-clone-dialog',
  templateUrl: './clone-dialog.component.html',
  styleUrls: ['./clone-dialog.component.scss'],
  encapsulation :ViewEncapsulation.None
})
export class CloneDialogComponent implements OnInit {
  id;
  name;
  header;
  label;
  type;
  constructor(
    public dialogRef: MatDialogRef<CloneDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) { 
    this.id = data.id;
    this.type = data.type;
    if(this.type == "poll"){
      this.header = "Clone Polls.";
      this.label = "Poll Name"
    }
    if(this.type == "group"){
      this.header = "Clone Group.";
      this.label = "Group Name"
    }
   }

  ngOnInit(): void {
    
  }

  clone(){
    debugger;
    if(this.type == "poll"){
      this._apiService.clonePoll(this.id,this.name).subscribe(res => {
        if (res) {
          console.log(res);
          this.dialogRef.close();
        }
      },
      (error)=>{
        console.log(error);
      });
    }

    if(this.type == "group"){
      this._apiService.cloneGroup(this.id,this.name).subscribe(res => {
        if (res) {
          console.log(res);
          this.dialogRef.close();
        }
      },
      (error)=>{
        console.log(error);
      });
    }
    
  }


  onClickClose(){
    this.dialogRef.close();
  }

}
